// transport.reducer.js

import {
  GET_TRANSPORT_REPORT_REQUEST,
  GET_TRANSPORT_REPORT_SUCCESS,
  GET_TRANSPORT_REPORT_FAILURE,
  TRANSPORT_REPORT_RESET,
} from "./constant"

const initialState = {
  data: [],
  loading: false,
  error: null,
}

const TransportReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_TRANSPORT_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      }

    case GET_TRANSPORT_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      }

    case GET_TRANSPORT_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }
    case TRANSPORT_REPORT_RESET:
      return {
        ...state,
        loading: false,
        data: [],
        error: null,
      }

    default:
      return state
  }
}

export default TransportReducer
